import { Injectable } from '@angular/core';

import { SizeHelperService } from '../../size-helper.service';
import { StageService } from '../../stage.service';
import { DataForDisplayingMenuItemsService } from '../../data-for-displaying-menu-items.service';
import { ConstantsService } from '../../constants.service';
import { HelperLinesService } from '../../helper-lines.service';
import { RailingPostsService } from '../post/services/railing-posts.service';
import { RailingColorsService } from './railing-colors.service';
import { InfillsForTiersService } from '../infills/infills-for-tiers.service';

declare const THREE: any;

@Injectable()
export class RailingForTiersService {
  infills: any;
  intermediatePost: any;
  handrail: any;
  baserail: any;
  currentParams: any;
  railingComponents: any;
  handrailMaterial: any;

  constructor(
    private sizeHelper: SizeHelperService,
    private infillsForTiers: InfillsForTiersService,
    private stage: StageService,
    private dataForMenu: DataForDisplayingMenuItemsService,
    private constants: ConstantsService,
    private helperLinesService: HelperLinesService,
    private railingPostsService: RailingPostsService,
    private railingColorsService: RailingColorsService
  ) { }

  buildInfillsBetweenTiers(infills, railingComponent) {
    this.infills = infills;
    this.railingComponents = railingComponent;
    this.updateCurrentParams();
    this.intermediatePost = railingComponent.intermediatePost;
    this.handrail = railingComponent.handrail;
    this.baserail = railingComponent.baserail;
    this.handrailMaterial = railingComponent.handrail.children[0].material.clone();

    const floors = this.stage.getCompoundFloor();
    for (let i = 0; i < floors.children.length; i++) {
      const floor = floors.children[i];

      for (let j = 0; j < floor.userData.points.length; j++) {
        if (floor.userData.points[j].superstructureType) {
          if (floor.userData.points[j].parent) {

          } else if (floor.userData.points[j].superstructureType === 'tier1StepDown' ||
            floor.userData.points[j].superstructureType === 'tier1StepUp' ||
            floor.userData.points[j].superstructureType === 'tier3StepDown' ||
            floor.userData.points[j].superstructureType === 'tier2StepUp' ||
            floor.userData.points[j].superstructureType === 'tier2StepDown' ||
            floor.userData.points[j].superstructureType === 'tier3StepUp') {
            this.addHandrailAndBaserailForTierSteps(floor, j);
          }
        }
      }
    }
  }

  addHandrailAndBaserailForTierSteps(floor, parentFirstPointIndex) {
    const parentFirstPoint = floor.userData.points[parentFirstPointIndex];
    const childCustomId = parentFirstPoint.childCustomId;
    const childTier = this.stage.getCompoundFloor().children.find(tier => tier.userData.customId === childCustomId);
    const childFirstPoint = childTier.userData.points[childTier.userData.points.length - 1];

    if (childFirstPoint && childFirstPoint.terminationPosts &&
      childFirstPoint.terminationPosts.first &&
      parentFirstPoint && parentFirstPoint.terminationPosts &&
      parentFirstPoint.terminationPosts.second
      ) {
        this.addNonHorizontalHandrailAndBaserail(
          childFirstPoint.terminationPosts.first,
          parentFirstPoint.terminationPosts.second,
          childFirstPoint.terminationPosts.firstPostTierToFloorHalfAngle,
          parentFirstPoint.terminationPosts.secondPostTierToFloorHalfAngle);
    }

    if (childFirstPoint && childFirstPoint.terminationPosts &&
      childFirstPoint.terminationPosts.second &&
      parentFirstPoint && parentFirstPoint.terminationPosts &&
      parentFirstPoint.terminationPosts.first
      ) {
        this.addNonHorizontalHandrailAndBaserail(
          childFirstPoint.terminationPosts.second,
          parentFirstPoint.terminationPosts.first,
          childFirstPoint.terminationPosts.secondPostTierToFloorHalfAngle,
          parentFirstPoint.terminationPosts.firstPostTierToFloorHalfAngle);
    }
  }

  addAngleToHandrail(obj, rightVerticalAngle, leftVerticalAngle, rightHorizontalAngle, leftHorizontalAngle) {
    const position = obj.geometry.attributes.position;
    const vertices = [];

    for (let i = 0, l = position.count; i < l; i++) {
      const vertice = new THREE.Vector3();
      vertice.fromBufferAttribute(position, i);
      vertice.applyMatrix4(obj.matrixWorld);
      vertices.push(vertice.clone());
    }

    for (let i = 0; i < vertices.length; i++) {

      // angle might be null (undefined),
      // in that case do not apply morph
      // manipulating vertical angles
      if (rightVerticalAngle && rightVerticalAngle > 0) {
        if (vertices[i].x > 0 && vertices[i].y > 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(rightVerticalAngle));
          const displacementVect = new THREE.Vector3(displacement, 0, 0);
          vertices[i].add(displacementVect);
        }

        if (vertices[i].x > 0 && vertices[i].y < 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(rightVerticalAngle));
          const displacementVect = new THREE.Vector3(-displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
      } else {
        if (vertices[i].x > 0 && vertices[i].y > 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(rightVerticalAngle));
          const displacementVect = new THREE.Vector3(-displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
        if (vertices[i].x > 0 && vertices[i].y < 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(rightVerticalAngle));
          const displacementVect = new THREE.Vector3(displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
      }

      if (leftVerticalAngle && leftVerticalAngle > 0) {
        if (vertices[i].x < 0 && vertices[i].y > 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(leftVerticalAngle));
          const displacementVect = new THREE.Vector3(-displacement, 0, 0);
          vertices[i].add(displacementVect);
        }

        if (vertices[i].x < 0 && vertices[i].y < 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(leftVerticalAngle));
          const displacementVect = new THREE.Vector3(displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
      } else {
        if (vertices[i].x < 0 && vertices[i].y > 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(leftVerticalAngle));
          const displacementVect = new THREE.Vector3(displacement, 0, 0);
          vertices[i].add(displacementVect);
        }

        if (vertices[i].x < 0 && vertices[i].y < 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(leftVerticalAngle));
          const displacementVect = new THREE.Vector3(-displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
      }
      // manipulating vertical angles

      // manipulating horizontal angles
      if (rightHorizontalAngle) {
        if (vertices[i].x > 0 && vertices[i].z > 0) {
          const displacement = Math.abs(vertices[i].z) * Math.tan(rightHorizontalAngle);
          const displacementVect = new THREE.Vector3(-displacement, 0, 0);
          vertices[i].add(displacementVect);
        }

        if (vertices[i].x > 0 && vertices[i].z < 0) {
          const displacement = Math.abs(vertices[i].z) * Math.tan(rightHorizontalAngle);
          const displacementVect = new THREE.Vector3(displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
      }

      if (leftHorizontalAngle) {
        if (vertices[i].x < 0 && vertices[i].z > 0) {
          const displacement = Math.abs(vertices[i].z) * Math.tan(leftHorizontalAngle);
          const displacementVect = new THREE.Vector3(-displacement, 0, 0);
          vertices[i].add(displacementVect);
        }

        if (vertices[i].x < 0 && vertices[i].z < 0) {
          const displacement = Math.abs(vertices[i].z) * Math.tan(leftHorizontalAngle);
          const displacementVect = new THREE.Vector3(displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
      }
      // manipulating horizontal angles
    }

    const morphArr = [];

    vertices.forEach(v => {
      morphArr.push(v.x, v.y, v.z);
    });

    obj.geometry.morphAttributes.position = [];
    obj.geometry.morphAttributes.position[0] = new THREE.Float32BufferAttribute(new Float32Array(morphArr), 3);
    obj.material.morphTargets = true;
    obj.updateMorphTargets();
    obj.morphTargetInfluences[0] = 1;
  }

  cloneObject3DMaterialAndGeometry(obj, material) {
    const newMesh = obj.clone();

    for (let i = 0; i < newMesh.children.length; i++) {
      if (newMesh.children[i]) {
        newMesh.children[i].geometry = obj.children[i].geometry.clone();
        newMesh.children[i].material = material;
      }
    }

    return newMesh;
  }

  addNonHorizontalHandrailAndBaserail(point1, point2, angle1, angle2) {
    const nonHorizontalHandrail = this.cloneObject3DMaterialAndGeometry(this.handrail, this.handrailMaterial);

    const firstPoint = new THREE.Vector3(point1.x, point1.y, point1.z);
    const secondPoint = new THREE.Vector3(point2.x, point2.y, point2.z);
    // HelperLinesService.buildOneTestLineAndUpdate(firstPoint);
    // HelperLinesService.buildOneTestLineAndUpdate(secondPoint);
    // post width might include other parts,
    // than just post itself, so it
    // might be missleading (to do: move this part
    // to db)
    const postWidth = this.intermediatePost.userData.entity.postWidth || this.intermediatePost.userData.entity.width;

    // data that need to calculate horizontal
    // distance, ignoring height
    const first2dVector = new THREE.Vector3(point1.x, 0, point1.z);
    const second2dVector = new THREE.Vector3(point2.x, 0, point2.z);
    const horizontalDist = first2dVector.distanceTo(second2dVector);
    ////

    // calculate legth of the handrail
    const firstPointEdge = firstPoint.clone();
    const secondPointEdge = secondPoint.clone();

    firstPointEdge.y += (nonHorizontalHandrail.userData.entity.placementHeight + nonHorizontalHandrail.userData.entity.height / 2);
    secondPointEdge.y += (nonHorizontalHandrail.userData.entity.placementHeight + nonHorizontalHandrail.userData.entity.height / 2);

    const firstToSecond = new THREE.Vector3(secondPoint.x - firstPoint.x, 0, secondPoint.z - firstPoint.z);
    const secondToFirst = new THREE.Vector3(firstPoint.x - secondPoint.x, 0, firstPoint.z - secondPoint.z);

    firstToSecond.setLength(postWidth / 2);
    secondToFirst.setLength(postWidth / 2);

    secondToFirst.negate();
    firstToSecond.negate();

    firstPointEdge.add(secondToFirst);
    secondPointEdge.add(firstToSecond);

    // rotate in vetical direction
    // to connect two posts (that have
    // different placementHeight)
    let angleY;
    if (secondPoint.y > firstPoint.y) {
      const verticalDist = secondPoint.y - firstPoint.y;
      angleY = Math.atan(verticalDist / (horizontalDist - postWidth));
    } else {
      const verticalDist = firstPoint.y - secondPoint.y;
      angleY = -(Math.atan(verticalDist / (horizontalDist - postWidth)));
    }

    // rotate in horizontal direction
    const norm = new THREE.Vector3(0, 0, 1);

    let angleZ = firstToSecond.angleTo(norm);
    if (firstToSecond.x < 0) {
      angleZ = -firstToSecond.angleTo(norm);
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // morph related,
    // mitering for handrails (that
    // consist of three parts). Need
    // to calculate angles between them
    // and apply morph for proper mitering
    const morphAngle = Math.abs(angleY) / 2;

    const morphDisplacement = (nonHorizontalHandrail.userData.entity.height * Math.tan(morphAngle)) / 2;

    const firstPointEdgeWithMorph = firstPointEdge.clone();
    const secondPointEdgeWithMorph = secondPointEdge.clone();

    const firstToSecondWithMorph = new THREE.Vector3(secondPointEdge.x - firstPointEdge.x, 0, secondPointEdge.z - firstPointEdge.z);
    const secondToFirstWithMorph = new THREE.Vector3(firstPointEdge.x - secondPointEdge.x, 0, firstPointEdge.z - secondPointEdge.z);

    firstToSecondWithMorph.setLength(morphDisplacement);
    secondToFirstWithMorph.setLength(morphDisplacement);

    if (firstPointEdgeWithMorph.y > secondPointEdgeWithMorph.y) {
      firstPointEdgeWithMorph.add(firstToSecondWithMorph);
      secondPointEdgeWithMorph.add(firstToSecondWithMorph);
    } else {
      firstPointEdgeWithMorph.add(secondToFirstWithMorph);
      secondPointEdgeWithMorph.add(secondToFirstWithMorph);
    }

    const nonHorizontalHandrailPositionWithMorph = new THREE.Vector3(firstPointEdgeWithMorph.x / 2 + secondPointEdgeWithMorph.x / 2,
      firstPointEdgeWithMorph.y / 2 + secondPointEdgeWithMorph.y / 2,
      firstPointEdgeWithMorph.z / 2 + secondPointEdgeWithMorph.z / 2);

    const nonHorizotalHandrailLength = firstPointEdgeWithMorph.distanceTo(secondPointEdgeWithMorph) / nonHorizontalHandrail.userData.entity.length;
    const scaleX = nonHorizotalHandrailLength;

    nonHorizontalHandrail.children.forEach(c => {
      if (c) {
        c.matrix.makeScale(scaleX, 1, 1);
        c.geometry.applyMatrix(c.matrix);
        if (firstPointEdgeWithMorph.y > secondPointEdgeWithMorph.y) {
          this.addAngleToHandrail(c, -morphAngle, morphAngle, null, null);
        } else {
          this.addAngleToHandrail(c, morphAngle, -morphAngle, null, null);
        }
      }
    });

    const horizontalHandrailLeft = this.cloneObject3DMaterialAndGeometry(this.handrail, this.handrailMaterial);
    const horizontalHandrailRight = this.cloneObject3DMaterialAndGeometry(this.handrail, this.handrailMaterial);

    horizontalHandrailLeft.rotation.y = angleZ + Math.PI / 2;
    horizontalHandrailRight.rotation.y = angleZ + Math.PI / 2;

    const leftPostPosition = new THREE.Vector3(firstPoint.x, firstPointEdgeWithMorph.y, firstPoint.z);

    const horizontalHandrailLeftScaleX = leftPostPosition.distanceTo(firstPointEdgeWithMorph) / horizontalHandrailLeft.userData.entity.length;
    const rightPostPosition = new THREE.Vector3(secondPoint.x, secondPointEdgeWithMorph.y, secondPoint.z);
    const horizontalHandrailRightScaleX = rightPostPosition.distanceTo(secondPointEdgeWithMorph) / horizontalHandrailRight.userData.entity.length;

    horizontalHandrailLeft.position.set(
      (leftPostPosition.x + firstPointEdgeWithMorph.x) / 2,
      firstPointEdgeWithMorph.y,
      (leftPostPosition.z + firstPointEdgeWithMorph.z) / 2
    );

    horizontalHandrailRight.position.set(
      (rightPostPosition.x + secondPointEdgeWithMorph.x) / 2,
      secondPointEdgeWithMorph.y,
      (rightPostPosition.z + secondPointEdgeWithMorph.z) / 2
    );

    horizontalHandrailLeft.children.forEach(c => {
      if (c) {
        c.matrix.makeScale(horizontalHandrailLeftScaleX, 1, 1);
        c.geometry.applyMatrix(c.matrix);
        if (firstPointEdgeWithMorph.y > secondPointEdgeWithMorph.y) {
          this.addAngleToHandrail(c, morphAngle, null, null, angle1);
        } else {
          this.addAngleToHandrail(c, -morphAngle, null, null, angle1);
        }
      }
    });

    horizontalHandrailRight.children.forEach(c => {
      if (c) {
        c.matrix.makeScale(horizontalHandrailRightScaleX, 1, 1);
        c.geometry.applyMatrix(c.matrix);
        if (firstPointEdgeWithMorph.y > secondPointEdgeWithMorph.y) {
          this.addAngleToHandrail(c, null, -morphAngle, angle2, null);
        } else {
          this.addAngleToHandrail(c, null, morphAngle, angle2, null);
        }
      }
    });
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////

    nonHorizontalHandrail.rotation.z = angleY;

    nonHorizontalHandrail.rotation.y = angleZ + Math.PI / 2;

    // set position of nonHorizontalHandrail,
    // -PointEdge variables are points
    // that placed on the edges of posts
    // and have the value for y that equal to
    // the placementHeight of already
    // build handrail
    nonHorizontalHandrail.position.set(
      nonHorizontalHandrailPositionWithMorph.x,
      nonHorizontalHandrailPositionWithMorph.y,
      nonHorizontalHandrailPositionWithMorph.z
    );
    ////
    this.railingColorsService.setExistingColor(nonHorizontalHandrail, 'Top Rail', 'Handrail');
    nonHorizontalHandrail.children.forEach(el => {
      if(el.name === 'TopCap'){
        this.railingColorsService.setExistingColor(nonHorizontalHandrail, 'Top Cap');
      }
    })
    this.stage.add(nonHorizontalHandrail);
    this.railingColorsService.setExistingColor(horizontalHandrailRight, 'Top Rail', 'Handrail');
    horizontalHandrailRight.children.forEach(el => {
      if(el.name === 'TopCap'){
        this.railingColorsService.setExistingColor(horizontalHandrailRight, 'Top Cap');
      }
    })
    this.stage.add(horizontalHandrailRight);
    this.railingColorsService.setExistingColor(horizontalHandrailLeft, 'Top Rail', 'Handrail');
    horizontalHandrailLeft.children.forEach(el => {
      if(el.name === 'TopCap'){
        this.railingColorsService.setExistingColor(horizontalHandrailLeft, 'Top Cap');
      }
    })
    this.stage.add(horizontalHandrailLeft);

    this.infills.push(nonHorizontalHandrail);

    this.infills.push(horizontalHandrailRight);

    this.infills.push(horizontalHandrailLeft);

    const baserailPosition = new THREE.Vector3(firstPointEdge.x / 2 + secondPointEdge.x / 2,
      (firstPoint.y + 20) / 2 + (secondPoint.y + 20) / 2,
      firstPointEdge.z / 2 + secondPointEdge.z / 2);
    const handrailPosition = new THREE.Vector3(firstPointEdge.x / 2 + secondPointEdge.x / 2,
      firstPointEdge.y / 2 + secondPointEdge.y / 2,
      firstPointEdge.z / 2 + secondPointEdge.z / 2);

    if (this.currentParams.infill !== 'horizontalCable') {
      const baserail = this.baserail.clone();

      // rotate baserail
      baserail.rotation.z = angleY;
      baserail.rotation.y = angleZ + Math.PI / 2;
      ////

      // set length of baserail
      const baserailLength = (firstPointEdge.distanceTo(secondPointEdge) + baserail.userData.entity.width) / baserail.userData.entity.length;
      baserail.scale.x = baserailLength;
      ////

      baserail.position.set(
        baserailPosition.x,
        baserailPosition.y,
        baserailPosition.z
      );

      this.stage.add(baserail);

      this.infills.push(baserail);
    }

    // add infills
    const infillHeight = baserailPosition.distanceTo(handrailPosition);
    const infillWidth = horizontalDist - postWidth;
    const infillCenterPosition = new THREE.Vector3(
      handrailPosition.x,
      (handrailPosition.y + baserailPosition.y) / 2,
      handrailPosition.z
    );
    const pos1 = new THREE.Vector3(
      firstPointEdge.x,
      firstPoint.y + 20,
      firstPointEdge.z);

    const pos2 = new THREE.Vector3(
      secondPointEdge.x,
      secondPoint.y + 20,
      secondPointEdge.z);

    // angleY, angleZ
    this.infillsForTiers.addInfill(
      point1, point2,
      pos1, pos2,
      infillHeight,
      infillWidth,
      infillCenterPosition,
      angleY,
      angleZ,
      this.infills,
      this.railingComponents
    );
  }

  updateCurrentParams() {
    this.currentParams = this.dataForMenu.getCurrentParams();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/railing/services/railing-for-tiers.service.ts